import React from 'react';
import { Box, Autocomplete, AutocompleteCloseReason } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import { PopperComponent, StyledInput } from './StyledComponents';

interface AutocompleteComponentProps {
	value: any;
	onValueChange: (newValue: any) => void;
	handleClose: () => void;
	options: any[];
	optionLabelAttribute: string;
	loadingOptions: boolean;
	theme: any;
}

const AutocompleteComponent = ({
	value,
	onValueChange,
	handleClose,
	options,
	optionLabelAttribute,
	loadingOptions,
	theme,
}: AutocompleteComponentProps) => (
	<Autocomplete
		open
		onClose={(
			event: React.ChangeEvent<{}>,
			reason: AutocompleteCloseReason,
		) => {
			if (reason === 'escape') {
				handleClose();
			}
		}}
		loading={loadingOptions}
		value={value}
		onChange={(event, newValue) => {
			onValueChange(newValue);
		}}
		disableCloseOnSelect
		PopperComponent={PopperComponent}
		renderTags={() => null}
		noOptionsText="No labels"
		renderOption={(props, option, { selected }) => (
			<OptionItem
				props={props}
				optionName={option[optionLabelAttribute]}
				selected={selected}
				theme={theme}
			/>
		)}
		options={options}
		getOptionLabel={(option) => option[optionLabelAttribute]}
		renderInput={(params) => (
			<StyledInput
				ref={params.InputProps.ref}
				inputProps={params.inputProps}
				autoFocus
				placeholder="Filter"
			/>
		)}
	/>
);

interface OptionItemProps {
	props: any;
	optionName: string;
	selected: boolean;
	theme: any;
}

const OptionItem = ({
	props,
	optionName,
	selected,
	theme,
}: OptionItemProps) => (
	<li {...props}>
		<Box
			component={DoneIcon}
			sx={{
				width: 17,
				height: 17,
				mr: '5px',
				ml: '-2px',
				visibility: selected ? 'visible' : 'hidden',
			}}
		/>
		<Box
			sx={{
				flexGrow: 1,
				'& span': {
					color:
						theme.palette.mode === 'light' ? '#586069' : '#8b949e',
				},
			}}
		>
			{optionName}
		</Box>
	</li>
);

export default AutocompleteComponent;
